<template>
	<div>		
		
		<div class="page-filter-box MT20">
		    <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="演出ID" :value="1"></el-option>
				            <el-option label="用户ID" :value="2"></el-option>
				            <el-option label="短信ID" :value="3"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.settleStatus" placeholder="请选择结算状态" size="small">
						<el-option :value="-1" label="不限制结算状态"></el-option>
						<el-option :value="1" label="仅看待结算的"></el-option>
						<el-option :value="2" label="仅看已结算的"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						  size="small"
					      v-model="params.startDate"
					      type="date"
					      placeholder="开始日期"
						  value-format="yyyy-MM-dd"
						  format="yyyy-MM-dd">
					    </el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						 size="small"
					      v-model="params.endDate"
					      type="date"
					      placeholder="结束日期"
						  value-format="yyyy-MM-dd"
						  format="yyyy-MM-dd">
					    </el-date-picker>
				</el-col>
		        <el-col  :xs="24" :sm="12" :md="16" :lg="12" :xl="8" class="page-filter-btns">					
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					<el-button v-if="$utils.have('/smsMarketing/fee/export')" type="primary" icon="el-icon-download" size="small"
					    @click="download" :loading="downLoading">导出明细</el-button>
		        </el-col>
		    </el-row>
		</div>
		<el-card  class="statistics-box" v-if="dataTop"  shadow="never">
		    <el-row :gutter="20">
		        <el-col :span="8"><p class="num">{{dataTop.totalFee || '0.00'}}</p><p class="color-info">计费总金额</p></el-col>
		        <el-col :span="8"><p class="num">{{dataTop.settledFee || '0.00'}}</p><p class="color-info">已结算总金额</p></el-col>
		        <el-col :span="8"><p class="num">{{dataTop.waitingSettleFee || '0.00'}}</p><p class="color-info">待结算金额</p></el-col>		        
		    </el-row>
		</el-card>		
		<div class="page-list-box MT20">
			<el-table :data="dataList" style="width: 100%" v-loading="listLoading" size="small"
				header-row-class-name="page-list-table">
				<el-table-column prop="marketingIdView" label="短信ID" min-width="130" show-overflow-tooltip></el-table-column>
				<el-table-column prop="smsType" label="短信触达类型">
					<template slot-scope="scope">
						<span v-if="scope.row.smsType == 1">演出购票营销触达</span>
						<span v-else-if="scope.row.smsType == 2">优惠券触达</span>
						<span v-else-if="scope.row.smsType == 3">膨胀红包触达</span>
					</template>
				</el-table-column>
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
				<el-table-column prop="userId" label="用户" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{scope.row.userName}}
						<P>ID:{{scope.row.userId}}</P>
					</template>
				</el-table-column>
				<el-table-column prop="count" label="触达条数"></el-table-column>
				<el-table-column prop="totalFee" label="金额(元)"></el-table-column>
				<el-table-column prop="sendTime" label="发送时间"></el-table-column>
				<el-table-column prop="settleStatus" label="结算状态">
					<template slot-scope="scope">
						{{scope.row.settleStatus == 1 ? '未结算' : scope.row.settleStatus == 2 ? '已结算' : '无需结算'}}
					</template>
				</el-table-column>
				<el-table-column prop="settleTime" label="结算时间"></el-table-column>
			</el-table>
		</div>
		<div v-if="data && data.feeList" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.feeList.totalCount || 0">
		    </el-pagination>
		</div>
	</div>
</template>
<script>
	import {downloadFileTmp} from '@/assets/js/commonApi.js';
	const defaultParams = {
		pageNo: 1,
		pageSize: 10,
		settleStatus: -1,
		searchType:1,
		searchValue:'',
		startDate:'',
		endDate:''
	}
	export default {
		components: {},
		data() {
			return {
				data: null,
				dataList: null,
				dataTop:null,
				params: {
					...defaultParams
				},
				listLoading: false,
				downLoading:false,
			}
		},

		created() {
			this.getTopData()
			this.getDataList();
		},
		methods: {
			getTopData(){
				this.$request({
						url: "/smsMarketing/fee/list",
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.dataTop = result
							
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//获取列表
			getDataList() {
				
				if ( ( this.params.startDate != '' && this.params.endDate !='') && this.params.startDate > this.params.endDate) {
				    return this.$message.error('开始时间不能大于结束时间');
				}
				
				this.listLoading = true;
				this.$request({
						url: "/smsMarketing/fee/list",
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result
							this.data.feeList = result.feeList;
							this.dataList = result.feeList.result;
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
				this.getTopData()
			},
			//重置
			reset() {
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize
				}
				this.getDataList();
				this.getTopData()
			},
			//导出
			async download(){
			    let filePath;
			    this.downLoading = true;
			    const res = await this.$request({
			        url:'/smsMarketing/fee/export',			        
			        method: "POST",
			        data: {
			        	...this.params
			        },
			    })
			        .catch(err => {
			            this.$message({message: err.message, type: 'error'});
			        })
			    const{state,msg,result} = res.data;
			    if(state == 1 && result){
			        filePath = result.url;
			    }else{
			        this.downLoading = false;
			        return this.$message.error(msg || '下载失败');
			    }   
			
			    await downloadFileTmp(filePath,'短信营销计费明细.'+this.$utils.getFileType(filePath));
			
			    this.downLoading = false;
			},
		}
	}
</script>

<style lang="scss" scoped>
.statistics-box{    
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>